import { motion } from "framer-motion";
import { Crown, Wand2, Wallet, MonitorSmartphone, Zap, ThumbsUp } from "lucide-react";

const features = [
  { icon: Crown, title: "Fitur Pro Terbuka", desc: "Semua fitur premium CapCut terbuka penuh — efek, filter, template, dan AI tools." },
  { icon: Wand2, title: "Editing Lebih Profesional", desc: "Ekspor tanpa watermark hingga resolusi 4K. Hasil edit terlihat jauh lebih pro." },
  { icon: Wallet, title: "Harga Hemat", desc: "Cuma Rp59.000 untuk 1 bulan penuh. Jauh lebih murah dari langganan resmi." },
  { icon: MonitorSmartphone, title: "Akses Fleksibel", desc: "Bisa dipakai di HP, Laptop, dan PC. Login dengan 1 perangkat sesuai kebutuhanmu." },
  { icon: Zap, title: "Proses Instan", desc: "Setelah pembayaran, akun langsung dikirim melalui WhatsApp. Tanpa nunggu lama." },
  { icon: ThumbsUp, title: "Praktis", desc: "Akun dari penjual, tinggal login dan langsung edit. Nggak ribet setup apa pun." },
];

export const CapCutFeatures = () => (
  <section className="py-24 bg-[#F8FAFC]" id="capcut-fitur">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-2xl mb-14"
      >
        <h2 className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
          Semua yang kamu butuhin buat <span className="text-blue-600">edit level pro</span>.
        </h2>
        <p className="mt-4 text-slate-600 text-base md:text-lg">Satu akun, semua fitur premium terbuka. Fokus ke karya, bukan ke batasan.</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map(({ icon: Icon, title, desc }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl bg-white border border-slate-200 p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(37,99,235,0.1)] hover:-translate-y-1.5 hover:border-blue-200 transition-[transform,box-shadow,border-color] duration-300"
            data-testid={`capcut-feature-${i}`}
          >
            <span className="inline-flex w-11 h-11 rounded-xl bg-blue-50 items-center justify-center">
              <Icon className="w-5 h-5 text-blue-600" strokeWidth={2.2} />
            </span>
            <h3 className="mt-4 font-capcut-heading text-lg font-bold text-slate-900">{title}</h3>
            <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
